import { connectUtil, PropsFromRedux } from 'base/src/utils/reduxUtil';
// import { useTheme } from 'base/src/utils/context/themeContext';
import { useEffect, useMemo } from 'react';
import { formatDate } from 'base/src/utils/stringUtil';
import { formatToBRL } from 'base/src/utils/mathUtil';
import Avatar from 'base/src/components/Avatar';
import { Tag } from 'base/src/components/Tag';
import { useNavigate } from 'react-router';
import { GetPagamentos } from '../../../../store/pagamento/actions/pagamentoAction';
import { RootStateCarteira } from '../../../../store/carteiraReducer';

import * as S from './styles';
import { HoverCard, HoverCardArrow, HoverCardContent, HoverCardPortal, HoverCardTrigger } from 'base/src/components/HoverCard';
import HoverAvatar from '../../../../components/HoverAvatar';
import { Tooltip, TooltipContent, TooltipTrigger } from 'base/src/components/Tooltip';
import NoData from 'base/src/components/NoData';

const connector = connectUtil(
  (state: RootStateCarteira) => ({
    Pagamentos: state.PagamentoReducer.Pagamento,
    CarteiraUsuario: state.CarteiraBaseReducer.CarteiraUsuario,
  }),
  { GetPagamentos }
);

export interface HistoricoPagamentoComponentProps extends PropsFromRedux<typeof connector> {}

function PagamentosTodos({ GetPagamentos, Pagamentos, CarteiraUsuario }: HistoricoPagamentoComponentProps) {
  // const { theme } = useTheme();
  const navigate = useNavigate();

  useEffect(() => {
    if (CarteiraUsuario.length > 0) {
      GetPagamentos({ From: '', To: '' }, CarteiraUsuario[0].CarteiraID, () => { });
    }
  }, [GetPagamentos, CarteiraUsuario]);

  const groupedPagamentos = useMemo(() => {
    return Pagamentos.reduce((acc, pagamento) => {
      const key = pagamento.DataOperacao;
      acc[key] = acc[key] || [];
      acc[key].push(pagamento);
      return acc;
    }, {} as Record<string, typeof Pagamentos>);
  }, [Pagamentos]);


  function handleClick(dataOperacao : string){
    return () => navigate(`/pagamento/${dataOperacao}`)
  }

  return (

    <S.Container>
      {Object.keys(groupedPagamentos).length > 0 ? (
      Object.entries(groupedPagamentos).map(([dataOperacao, pagamentos]) => {
        const uniqueAvatars = Array.from(
          new Map(
            pagamentos.flatMap(p => p.Pagos).map(pago => [pago.Avatar, pago])
          ).values()
        ).slice(0, 3);

        const totalItems = Math.max(1, pagamentos.reduce((sum, p) => sum + p.QuantidadePremiacoesPagas, 0));
        const totalValue = formatToBRL(
          pagamentos.reduce((sum, pagamento) => {
            return sum + Number(pagamento.ValorTransacao)
          }, 0)
        );

        const hasPending = pagamentos.some(pagamento =>
          pagamento.Pagos.some(pago => pago.Status === 'PENDING')
        );

        const hasError = pagamentos.some(pagamento =>
          pagamento.Pagos.some(pago => pago.Status === 'ERROR' || pago.Status === 'CANCELLED')
        );
        

        return (
          <S.InfoContainer key={dataOperacao} onClick={handleClick(dataOperacao)}>
            <S.OrderHeader>
              <S.OrderDetails>
                <S.OrderItem>
                  <S.Column>
                    <span>{formatDate(dataOperacao)}</span>
                  </S.Column>
                  <S.Column>

                    <span style={{ textAlign: 'center' }}>{totalItems} item(s)</span>
                  </S.Column>
                  <S.Column>
                    

                    <Tooltip>
                      <TooltipTrigger style={{background: "transparent", border: "none", padding: 0}}>
                        <Tag variant={hasPending ? 'warning' : hasError ? 'danger' : 'positive'}>
                          {hasPending ? 'Pagamento em andamento' : hasError ? 'Pagamento com erro' : 'Pago'}
                        </Tag>
                      </TooltipTrigger>
                      
                      <TooltipContent >
                        {hasPending ? 'Os pagamentos foram agendados e estão em processo de confirmação.' : hasError ? 'Algum(s) dos pagamentos foram cancelados por motivos diversos, clique para detalhar.' : 'Todos as premiações foram pagas com sucesso.'}
                      </TooltipContent>
                      
                    </Tooltip>
                  </S.Column>
                  <div style={{ display: 'flex', gap: 10, alignItems: "center", justifyContent: 'center' }}>
                    {uniqueAvatars.map((pago, idx) => (
                      // <Avatar
                      
                      //   key={idx}
                      //   src={pago.Avatar}
                      //   borderColor={theme.colors.primary}
                      //   size="xs"
                      //   alt="top"
                      //   fallBack={StringUtil.GetFirstLetters(pago.UsuarioNome)}
                      // />
                      <HoverCard key={idx}>
                        <HoverCardTrigger asChild>
                          <button style={{ background: "transparent", border: "none", padding: 0 }}>
                            <Avatar
                              size='md'
                              alt={pago.UsuarioNome || 'User avatar'}
                              fallBack={pago.UsuarioNome?.substring(0, 2) || 'U'}
                              borderColor='transparent'
                              src={pago.Avatar}
                            />
                          </button>
                        </HoverCardTrigger>
                        <HoverCardPortal>
                          <HoverCardContent side='top'>
                            <HoverCardArrow />
                            <HoverAvatar user={{
                              NomeCompleto: pago.UsuarioNome,
                              UsuarioAcesso: pago.UsuarioAcesso,
                              CPF: pago.UsuarioCpf,
                              Email: pago.Email,
                              ChavePix: pago.ChavePix,
                              ImagemUrl: pago.Avatar,
                              TelefoneCelular: '',
                              TelefoneFixo: '',
                              UsuarioID: 0,
                              DataNascimento: new Date(),
                              NomeExibicao: pago.UsuarioNome,
                              Token: '',
                              TokenPushNotification: '',
                              ManterConectado: false,
                              EmpresaID: 0,
                            }} />
                          </HoverCardContent>
                        </HoverCardPortal>
                      </HoverCard>
                      
                    ))}
                    {pagamentos.flatMap(p => p.Pagos).length > 3 && <span>+</span>}
                  </div>
                  <S.Column>
                    <span style={{ textAlign: 'end' }}>{totalValue}</span>
                  </S.Column>
                </S.OrderItem>
              </S.OrderDetails>
            </S.OrderHeader>
          </S.InfoContainer>
        );
      })
      ) : (
        <NoData />
      )}
    </S.Container>
  );
}

export default connector(PagamentosTodos);
